<template>
  <el-dialog
    title="批量设置分摊模式/分摊对象"
    :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true"
    width="90vw" @close="onClose">
    <div>
      <div>
        <el-select size="mini" v-model="template_id" filterable clearable placeholder="请选择分摊模板">
          <el-option v-for="(item,index) in apportion_template_list" :key="index" :label="item.full_name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <el-table
          :data="meter_list"
          border height="50vh" width="99%">
<!--          <el-table-column type="selection" width="50"></el-table-column>-->
          <el-table-column
            prop="number"
            label="仪表编号"
            width="160" fixed>
            <template slot-scope="scope">
              <el-link type="primary">{{scope.row.number}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="仪表名称"
            width="200">
          </el-table-column>
          <el-table-column
            prop="ancestor_name"
            label="房产" width="320">
          </el-table-column>
          <el-table-column
            prop="energy"
            label="能耗类型"
            width="100">
            <template slot-scope="scope">
              {{meterEnergyName(scope.row.energy)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="meter_level"
            label="等级"
            width="60">
            <template slot-scope="scope">
              <el-link type="primary">{{meterLevelName(scope.row.meter_level)}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="children_count"
            label="下级数量"
            width="90">
          </el-table-column>
          <el-table-column
            prop="apportion_type_name"
            label="分摊模式"
            width="100">
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
<!--              <el-button type="primary" size="mini" icon="el-icon-edit" @click="updateEdit(scope.row)">设置</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <template slot="footer">
      <div>
        <el-button icon="el-icon-close" type="warning" @click="onClose">关 闭</el-button>
        <el-button type="primary" @click="setMeterApportion" :loading="down_loading">设 置</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import MeterHttp from "../../../common/MeterHttp";

export default {
  name: "SelectApportionWin",
  data(){
    return{
      dialogVisible:false,
      apportion_template_list:[],
      project_id:0,
      meter_list:[],
      callback:null,
      down_loading:false,
      template_id:"",
    }
  },
  methods:{
    show({project_id=0,meter_list=[],callback=null}){
      const that=this;
      that.project_id=project_id;
      that.getApportionTemplateList(()=>{
        that.meter_list=meter_list;
        that.dialogVisible=true;
        that.callback=callback;
        that.down_loading=false;
      })
    },
    onClose(){
      this.dialogVisible=false;
      this.project_id=0;
      this.meter_list=[];
      this.apportion_template_list=[];
      this.callback=null;
      this.down_loading=false;
    },
    getApportionTemplateList(callback){
      const that=this;
      MeterHttp.post("MeterApportionTemplate/getList",{
        project_id:that.project_id,
        user_type:(that.$route.query.type||0),
        page: 1,
        pageSize: 200
      }, ret=>{
        if (ret.code) {
          let apportion_template_list=ret.data.list.map(ret=>{
            let apportion_type_name=getApportionTypeName(ret.apportion_type);
            ret.full_name=`${ret.name}【${apportion_type_name}-${ret.customer_count}户】`;
            return ret;
          })
          that.apportion_template_list = ERP.reJson(apportion_template_list);
          typeof callback==="function"&&callback()
        }
      })
    },
    setMeterApportion(){
      const that = this;
      if(!that.template_id){
        that.$message.error("请选择分摊模板");
        return false;
      }
      let meter_ids=that.meter_list.map(ret=>ret.id);
      that.down_loading=true;
      MeterHttp.post("MeterApportionTemplate/setMeterApportion",{
        project_id:that.project_id,
        template_id:that.template_id,
        meter_ids:JSON.stringify(meter_ids),
        user_type:(that.$route.query.type||0),
      }, res=>{
          that.down_loading=false;
          if (res.code) {
            typeof that.callback==="function"&&that.callback();
            that.dialogVisible=false;
            that.$message.success('设置成功')
          }else {
            that.$message.error(res.msg||'设置失败')
          }
      });
    },
    meterLevelName(meter_level){
      let level_obj={
        1:"一级",
        2:"二级",
        3:"三级",
        4:"四级",
      };
      return level_obj[meter_level]||"";
    },
    meterEnergyName(energy){
      let energy_obj={
        1:"业主能耗",
        2:"物业能耗",
        3:"分摊能耗",
      };
      return energy_obj[energy]||"";
    },
  }
}

const getApportionTypeName = (apportion_type) => {
  let apportion_type_obj={
    average:"平均分摊",
    area:"面积分摊",
    usage:"用量分摊",
    floor:"楼层分摊",
    currency:"通用分摊"
  }
  return apportion_type_obj[apportion_type]||""
}
</script>

<style lang="scss" scoped>
@import "../../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/SelectApportionWin.vue